module.exports = __webpack_public_path__ + "img/insta-4.66f2001c.jpg";